// shared
import { validString } from "Components/shared/helpers/validations";
// helpers
import { reverseShape } from "Helpers/reverse-shape";
// types
import { UserRoleToAssign } from "Types/user.types";
// yup
import * as Yup from "yup";

const AllUserRoles = Object.values(UserRoleToAssign);

const EmploymentDetailsSchema = Yup.object().shape(
  reverseShape({
    company: Yup.string().when("$isOrgCustomer", (isOrgCustomer, schema) => {
      return isOrgCustomer === true ? schema.required() : schema.notRequired();
    }),
    location: Yup.string().when("$isOrgCustomer", (isOrgCustomer, schema) => {
      return isOrgCustomer === true ? schema.required() : schema.notRequired();
    }),
    department: validString.optional(),
    subType: Yup.string().oneOf(AllUserRoles).required(),
  }),
);

export default EmploymentDetailsSchema;
